module.exports = __webpack_public_path__ + "img/logo-ersaf-single.0217feb6.png";